import axios from "axios";

interface APIError {
    message: string;
    path?: string;
}

interface PayloadError {
    name: string;
    message: string;
    data?: {
        errors?: APIError[];
        [key: string]: any;
    };
}

export const handleApiError = (
    error: any,
) => {
    let errorMsg = "";
    if (axios.isAxiosError(error)) {
        const payloadErrors = error.response?.data?.errors;

        if (Array.isArray(payloadErrors)) {
            const first = payloadErrors[0];
            if (first?.data?.errors?.length > 0) {
                // e.g., validation errors like email already exists
                errorMsg = (first.data.errors[0].path + ": " + first.data.errors[0].message);
            } else if (first?.message) {
                // e.g., general error with message
                errorMsg = (first.message);
            } else {
                errorMsg = ('An unknown error occurred.');
            }
        } else if (error.response?.data?.message) {
            // e.g., single message
            errorMsg = (error.response.data.message);
        } else {
            errorMsg = ('An unexpected error occurred.');
        }
    } else {
        errorMsg = ('A network or unknown error occurred.');
    }

    return errorMsg;
};
